import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {SegmentIndustry} from '../../../../models/measure/report';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import { pieChartConfig, chartConfig } from '../../../app.constants';

@Component({
  selector: 'industry-drill-down-report',
  templateUrl: './industry-drill-down-report.component.html',
  styleUrls: ['./industry-drill-down-report.component.scss']
})
export class IndustryDrillDownReportComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'IndustryDrillDownReportComponent';
  @Input()
  segementIndustry: SegmentIndustry;
  @Input()
  pieCenter: [number];
  @Input()
  pieSize: string;

  public industryPieChartData = [];
  public industryLineData = [];

  public chartHeight: number;
  public chartTitleStyling: object;
  public chartInnerSize: string;
  public chartLegend: object;

  constructor(private pdfService: PdfExportService) {
    this.loadPieChartStyling();
  }

  ngOnInit() {
    this.industryPieChartData = this.segementIndustry.pieChart.map((pie) => ({
        name: pie.name,
        y: pie.value
      })
    );
    this.industryLineData = this.segementIndustry.barChart.map(line => ({
        name: line.name,
        y: line.value
      })
    );
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(IndustryDrillDownReportComponent.COMPONENT_NAME);
  }

  get haveNoData() {
    if (!this.segementIndustry) {
      return true;
    }

    return this.segementIndustry.barChart.length === 0
      && this.segementIndustry.pieChart.length === 0;
  }

  private loadPieChartStyling() {
    this.chartHeight = chartConfig.industryDrillDownChart.chartHeight;
    this.chartInnerSize = pieChartConfig.pdfView.pieChartInnerSize;
    this.chartTitleStyling = chartConfig.industryDrillDownChart.titleStyling;
    this.chartLegend = chartConfig.industryDrillDownChart.chartLegend;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/industry-drill-down-report/industry-drill-down-report.component.ts